export default {
	devices_selected_count: {
		en: 'Devices selected',
		ge: 'არჩეული მოწყობილობები',
		de: 'Ausgewählte Geräte',
		ru: 'Выбрано устройств',
		cn: 'Devices selected',  // TODO: translation needed
	},
};
